import React from "react";
import CloseIcon from "@mui/icons-material/Close";

// Removing a tag applies immediately — no sheet round-trip, per README (1).md.
export default function ActiveFilterTags({ tags, onRemove }) {
  if (!tags || tags.length === 0) return null;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 12 }}>
      {tags.map((tag) => (
        <button
          key={`${tag.dimension}:${tag.value}`}
          type="button"
          onClick={() => onRemove(tag)}
          aria-label={`Remove filter ${tag.label}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            minHeight: 32,
            padding: "4px 8px 4px 12px",
            border: "1px solid #D0D5DD",
            borderRadius: 999,
            background: "#fff",
            fontFamily: "Inter-Medium",
            fontSize: 13,
            color: "#101828",
            cursor: "pointer",
          }}
        >
          {tag.label}
          <CloseIcon sx={{ fontSize: 16, color: "#667085" }} />
        </button>
      ))}
    </div>
  );
}
